import { Checkbox } from "@fluentui/react";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Truncate } from "../components-utils";
import { ColumnOptionsContext } from "./ColumnOptions";
import { Column, TaxonomyFilter as TaxonomyFilterType } from "./types";

type Props = {
  column: Column;
};

export const TaxonomyFilter = ({ column }: Props) => {
  const filter = column.filter as TaxonomyFilterType;
  const selectedValues = filter.value;

  const renderLabel = filter.renderLabel;
  const { taxonomy, setFilter, t, id } = useContext(ColumnOptionsContext);
  const [maxSelectionReached, setMaxSelectionReached] = useState(false);

  const options = (taxonomy[filter.taxonomyKey] || []).filter((tax) => {
    if (filter.exclude) {
      return !filter.exclude.includes(tax.code);
    }
    return true;
  });

  const handleMaxSelectionReached = () => {
    if (
      filter?.maxOptionsSelect &&
      selectedValues.length >= filter?.maxOptionsSelect
    ) {
      setMaxSelectionReached(true);
    } else {
      maxSelectionReached && setMaxSelectionReached(false);
    }
  };
  useEffect(() => {
    handleMaxSelectionReached();
  }, [selectedValues]);

  return (
    <div>
      {options.map((tax) => {
        const isChecked = selectedValues.includes(tax.id);
        return (
          <CheckboxWrapper key={tax.id}>
            <StyledCheckbox
              checked={isChecked}
              disabled={maxSelectionReached && !isChecked}
              id={
                id
                  ? `${id}-taxonomyFilter-${column.key}-${tax.code}`
                  : undefined
              }
              onChange={(_, checked) => {
                let value;
                if (checked) {
                  if (maxSelectionReached && !isChecked) return;
                  value = selectedValues.concat([tax.id]);
                } else {
                  value = selectedValues.filter((vId) => vId !== tax.id);
                }

                setFilter(column.key, {
                  ...filter,
                  value,
                });
              }}
            />
            {renderLabel ? (
              renderLabel({ taxonomy: tax, t })
            ) : (
              <Truncate>{t(tax.code)}</Truncate>
            )}
          </CheckboxWrapper>
        );
      })}
    </div>
  );
};

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  margin-right: 2px;
`;
